import * as Yup from 'yup';
import { ERRORS } from '../constants/base';
import { manualAddressFieldTests } from './manualAddressRules';

export const addressSchema = Yup.object().shape({
    type: Yup.string().when('fullAddress', {
        is: (fullAddress: string) => !!fullAddress,
        then: (schema) => schema.required(ERRORS.required),
        otherwise: (schema) => schema.nullable(),
    }),
    // A geocoded address must be picked from the suggestions (place_id set). A MANUAL
    // address is hand-entered with no place_id by design, and a TEXT-ONLY address has no
    // place_id/coordinates at all by design, so the requirement is lifted for both.
    place_id: Yup.string().when(['fullAddress', 'is_manual', 'is_text_only'], {
        is: (fullAddress: string, is_manual: boolean, is_text_only: boolean) =>
            !!fullAddress && !is_manual && !is_text_only,
        then: (schema) => schema.required(ERRORS.address_not_selected),
        otherwise: (schema) => schema.nullable(),
    }),
    // A manual address the user is KEEPING must carry in-range coordinates (the only typed
    // requirement); its hidden country must have been seeded from the workspace Default Region.
    // These rules are shared across every form via manualAddressFieldTests so they never drift.
    ...manualAddressFieldTests(),
})
